import { useEffect } from 'react';
import { useApiGet } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { Study } from '../../models/Study';

export function useGetStudy(id: number) {
  const { logError } = useAppContext();
  const { data, isLoading, error, get } = useApiGet<Study>(`studies/${id}`);
  useEffect(
    () => void (error && logError('Get Study Detail Error', error)),
    [error, logError]
  );
  return {
    study: data,
    loadingStudy: isLoading,
    loadingStudyError: error,
    getStudy: get
  };
}
